module.exports = __webpack_public_path__ + "img/gift-template.1ecae6c0.png";